var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formatUSPhone",on:{"click":function($event){return _vm.onCopyToClipboard(_vm.formatUSPhone)}}},[_vm._v(_vm._s(_vm.formatUSPhone))])
}
var staticRenderFns = []

export { render, staticRenderFns }